import React, { useState } from 'react';
import { useTranslation } from '../../utils/useTranslation';
import { SmartDrawer } from '../feedback/SmartDrawer';
import { Button } from '../input/Button';
import { FormControl } from '../input/FormControl';
import { Input } from '../input/Input';
import { Flex } from '../layout/Flex';
import { Typography } from '../typography/Typography';

interface AddProductDrawerProps {
    handleClose: VoidFunction;
    error?: Error;
    addProduct: (productLink: string) => void;
    loading: boolean;
    onChangeUrl: VoidFunction;
}

export const AddProductDrawer = (props: AddProductDrawerProps) => {
    const { handleClose, addProduct, error, loading, onChangeUrl } = props;
    const [productLink, setProductLink] = useState('');
    const t = useTranslation();

    return (
        <SmartDrawer
            onClose={handleClose}
            titleContent={
                <Typography variant="title3" weight="bold">
                    Добавить товары
                </Typography>
            }
            mainContent={
                <>
                    <Typography pb={1.5}>{t('Вставьте ссылку на товар')}</Typography>
                    <Flex width="100%" direction="row" spacing={2} alignItems="center" pb={3}>
                        <FormControl
                            label="Ссылка на товар"
                            disabled={loading}
                            error={Boolean(error)}
                            message={error?.message}
                        >
                            <Input
                                value={productLink}
                                type="text"
                                autoComplete="off"
                                placeholder="https://"
                                onChange={(e) => {
                                    setProductLink(e.currentTarget.value);
                                    onChangeUrl();
                                }}
                            />
                        </FormControl>
                    </Flex>
                    <Button
                        size="l"
                        width="100%"
                        disabled={loading}
                        onClick={() => addProduct(productLink)}
                    >
                        {t('Добавить')}
                    </Button>
                </>
            }
        />
    );
};
